import { WidgetFlowStartButtonBlock } from '@/blocks/WidgetFlowStartButtonBlock'

// Components that have app router dependencies and would break in pages router
// Move to commonStoryblokComponents once we have fully migrated to app router
export const appRouterStoryblokComponents = {
  widgetFlowStartButton: WidgetFlowStartButtonBlock,
}
